import { useOutletContext } from "react-router-dom";
import type { MeetingRunContext } from "../MeetingRunContext";
import {
  useImmediateMutationSystem,
  type Mutator,
} from "@/lib/queuedMutations";
import { TextArea } from "@repo/ui/components/Base/TextArea";
import { CollapsiblePanel } from "../CollapsiblePanel";
import { getSectionById } from "./sections";
import type { MeetingRunSectionProps } from "./meetingRunSectionProps";
import {
  agendaItemRepo,
  type AgendaItemDto,
} from "@/repositories/agendaItemRepo";
import { useFutureCallback } from "@repo/ui/components/Base/hooks/useFutureCallback";

export const MeetingRunDiscussionSection = ({
  id,
  idSuffix,
  className,
  open,
  onToggle,
}: MeetingRunSectionProps) => {
  const {
    tenantId,
    meeting,
    agendaItem: _item,
    mutationSystem,
  } = useOutletContext() as MeetingRunContext;

  const mutationKey = "agendaItem:" + _item!.id;

  const agendaItemMutation: Mutator<AgendaItemDto> = useFutureCallback(
    async (id, data) => {
      await agendaItemRepo.update(tenantId, id, data);
    }
  );
  const agendaItem = useImmediateMutationSystem(
    mutationSystem,
    mutationKey,
    _item!
  );

  return (
    <CollapsiblePanel
      id={id}
      idSuffix={idSuffix}
      title={getSectionById("discuss").title}
      className={className}
      open={open}
      onToggle={onToggle}
    >
      <h1 className="mt-5 text-2xl font-bold">Discussion and Debate</h1>
      <TextArea
        id="comments"
        label="Discussion Summary"
        className="h-60"
        value={agendaItem.review?.comments ?? ""}
        onChange={(evt) => {
          mutationSystem.debounce(
            mutationKey,
            agendaItemMutation,
            {
              review: {
                ...agendaItem.review,
                meetingId: meeting.id,
                comments: evt.target.value,
              },
            },
            agendaItem.id
          );
        }}
      />
    </CollapsiblePanel>
  );
};
